import PaletteIcon from "@mui/icons-material/Palette";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from "@vapor/react-material";
import React, { useState } from "react";
import { LABEL_COLORS, TagColor } from "./colors";
import "./style.scss";

interface TagProps {
    children: React.ReactNode | string;
    color?: TagColor;
    ghost?: boolean;
}

const Tag = (props: TagProps) => {
    return (
        <span
            className={`ts-vapor-tag ts-vapor-tag-${props.ghost ? "ghost" : "standard"} ${props.color}`}
        >
            {props.children}
        </span>
    );
};

Tag.defaultProps = {
    color: TagColor.blueSapphire,
    ghost: false,
};

export default Tag;

export const ColorButton = (props: {
    colorChoice: TagColor;
    onChange: (c: TagColor) => void;
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSelect = (color: TagColor) => {
        props.onChange(color);
        handleClose();
    };
    return (
        <>
            <div className={props.colorChoice}>
                <IconButton onClick={handleOpen}>
                    <PaletteIcon htmlColor="white" />
                </IconButton>
            </div>
            <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
                <DialogTitle>Scegli un colore</DialogTitle>
                <DialogContent>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            justifyContent: "center",
                            padding: "8px 0",
                        }}
                    >
                        {LABEL_COLORS.map((color: TagColor) => (
                            <div
                                className={color}
                                key={color}
                                onClick={() => handleSelect(color)}
                                style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    border:
                                        color === props.colorChoice
                                            ? "2px solid black"
                                            : "1px solid rgba(0,0,0,0.2)",
                                }}
                            />
                        ))}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
